import { GlobalImages } from '@flowus/common';
import { cx } from '@flowus/common/cx';
import { useOpenModal } from '@flowus/common/next-modal';
import { Tooltip } from '@flowus/common/tooltip';
import type { FC } from 'react';
import { Avatar } from 'src/common/components/avatar';
import { Icon } from 'src/common/components/icon';
import { publicLink } from 'src/common/const';
import { PRODUCT_NAME } from 'src/const/title';
import { useCurrentUser } from 'src/hooks/user';
import { useIsFullscreen } from 'src/services/desktop';
import { isMacElectron } from 'src/utils/electron';
import { TocCollapseButton } from '../toc-trigger';
import { SubscribeNotification } from './subscribe-notification';

interface Props {}
export const SubscribeAsideHeader: FC<Props> = () => {
  const isFullscreen = useIsFullscreen();
  const isDesktopMode = isMacElectron && !isFullscreen;
  const user = useCurrentUser();
  if (!user) return null;

  return (
    <>
      <div
        className={cx(
          'relative flex items-center px-4 py-2.5 justify-between',
          isDesktopMode && 'pt-11'
        )}
      >
        <div className="space-x-2 flex items-center">
          <Avatar
            className="flex-shrink-0"
            imgClassName="rounded-full"
            name={user.nickname}
            iconSize={26}
            color={user?.backgroundColor || undefined}
            icon={user?.avatar ? { type: 'upload', value: user.avatar } : undefined}
          />
          <div className="flex items-center select-none text-t2-medium line-clamp-1">
            {user.nickname}
          </div>
        </div>
        <TocCollapseButton />
      </div>
      <QuickButton />
    </>
  );
};

const QuickButton = () => {
  const openModal = useOpenModal();

  const openWeChatAccount = () => {
    openModal.warning({
      title: `关注 ${PRODUCT_NAME} 公众号，接收订阅推送消息`,
      colorType: 'active',
      noCancel: true,
      confirmText: '知道了',
      content: (
        <div className="flex flex-col items-center justify-center space-y-4">
          <img src={GlobalImages.qr} className="w-32 h-32" alt="" />
        </div>
      ),
    });
  };

  const openHelper = () => {
    window.open(publicLink.subscribeRule);
  };

  return (
    <div className="grid grid-cols-3 text-grey3 px-5 py-1.5 mb-2">
      <SubscribeNotification />
      {!__BUILD_IN__ && (
        <>
          <Tooltip
            placement="bottom"
            popup="微信接收订阅推送消息"
            onClick={openWeChatAccount}
            className="animate-click animate-hover p-1"
          >
            <Icon name="IcWechat" size="middle" />
          </Tooltip>
          <Tooltip
            onClick={openHelper}
            placement="bottom"
            popup="了解FlowUs知识库订阅"
            className="animate-click animate-hover p-1"
          >
            <Icon name="IcQuestion" size="middle" />
          </Tooltip>
        </>
      )}
    </div>
  );
};
